"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isQuoteAuthorProperty = exports.quoteAuthorPropertyDefinition = void 0;
exports.quoteAuthorPropertyDefinition = {
    view: { label: 'Author' },
    constraints: [],
    type: 'text',
    multiple: false,
    name: 'quote-author',
};
const isQuoteAuthorProperty = (prop) => {
    return prop.name === exports.quoteAuthorPropertyDefinition.name;
};
exports.isQuoteAuthorProperty = isQuoteAuthorProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicXVvdGUtYXV0aG9yLnByb3BlcnR5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3Byb3BlcnRpZXMvcXVvdGUtYXV0aG9yLnByb3BlcnR5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVhLFFBQUEsNkJBQTZCLEdBQUc7SUFDM0MsSUFBSSxFQUFFLEVBQUUsS0FBSyxFQUFFLFFBQVEsRUFBRTtJQUN6QixXQUFXLEVBQUUsRUFBRTtJQUNmLElBQUksRUFBRSxNQUFNO0lBQ1osUUFBUSxFQUFFLEtBQUs7SUFDZixJQUFJLEVBQUUsY0FBYztDQUNXLENBQUE7QUFJMUIsTUFBTSxxQkFBcUIsR0FBRyxDQUFDLElBQWtCLEVBQStCLEVBQUU7SUFDdkYsT0FBTyxJQUFJLENBQUMsSUFBSSxLQUFLLHFDQUE2QixDQUFDLElBQUksQ0FBQTtBQUN6RCxDQUFDLENBQUE7QUFGWSxRQUFBLHFCQUFxQix5QkFFakMifQ==